export default "__VITE_ASSET__CRzgDWFu__"